module.exports = __webpack_public_path__ + "img/math-2.b0993652.png";